module.exports = __webpack_public_path__ + "img/15.b91f4b84.png";